<template>
  <main class="container my-5" :class="{ pagamentoCartao: cartaoForm }">
    <div class="aguarde-container  text-center" v-if="btnLoading">
      <div class="spinner-border" role="status"></div>
      <br>
      <span>Aguarde...</span>
    </div>
    <article class="CardConfirmarPedido w-100" v-if="!btnLoading">
      <div class="mensageminicial" v-if="!objPedido.id">
        <span class="mensageminicial__icon button-loader"></span>
        <p class="mensageminicial__frase">Verificando dados</p>
      </div>
      <div v-else-if="!btnLoading">
        <div class="container text-center px-3 px-lg-5">
          <img class="w-25 mt-5 mb-3" style="max-width: 140px"
            src="https://pagglo-cdn.s3.amazonaws.com/app/assets/bid.png" alt="" />
          <h3>R$ {{ formatPrice(this.pagamento.valor) }}</h3>
          <h6 class="m-4">
            {{ objPedido.redeLoja && objPedido.redeLoja.nome ? objPedido.redeLoja.nome : "" }}
          </h6>
          <small class="d-block m-2 text-bold text-muted" v-if="!btnLoading">Escolha uma forma de pagamento</small>
          <small class="d-block m-2 text-bold text-muted" v-else>
            Processando seu pagamento
            <span class="button-loader grey ml-2"></span>
          </small>
        </div>
        <div v-if="!cartaoForm">
          <ul class="list-group text-muted list-group-flush px-3 px-lg-5">
            <li class="
                list-group-item
                px-4
                d-flex
                justify-content-between
                align-items-center
              " style="border-top-width: 1px" @click="prosseguirConfirmacaoPagamento('SALDO_CARTEIRA')"
              v-if="carteira.valor > 0">
              <span>
                <img :src="icons.extratoDeposito" alt="carteira" style="width: 30px" />
              </span>

              <span class="container">Saldo Carteira<span class="ml-2" v-if="carteira.valor">R$ {{
                formatPrice(carteira.valor)
              }}</span></span>
              <span class="align-self-center h3 mt-2" style="color: var(--cor-principal)">&#10097;</span>
            </li>
            <li @click="prosseguirConfirmacaoPagamento('SALDO_CARTEIRA_CASHBACK')" v-if="carteira.valorCashback > 0"
              class="
                list-group-item
                px-4
                d-flex
                justify-content-between
                align-items-center
              " style="border-top-width: 1px">
              <span>
                <img :src="icons.extratoDeposito" alt="carteira" style="width: 30px" />
              </span>
              <span class="container">
                <span>
                  Saldo Carteira (R$ {{ formatPrice(carteira.valor) }}) +
                  Cashback (R$ {{ formatPrice(carteira.valorCashback) }})
                </span>
              </span>
              <span class="align-self-center h3 mt-2" style="color: var(--cor-principal)">&#10097;</span>
            </li>
            <li @click="adicionarCobrancaPix" class="
                list-group-item
                px-4
                d-flex
                justify-content-between
                align-items-center
              " style="border-top-width: 1px" v-if="pagamentoPix">
              <span>
                <img :src="icons.pix" alt="pix" style="width: 30px" />
              </span>
              <span class="container">PIX</span>
              <span class="align-self-center h3 mt-2" style="color: var(--cor-principal)">&#10097;</span>
            </li>

            <li @click="adicionarBoleto" class="
                list-group-item
                px-4
                d-flex
                justify-content-between
                align-items-center
              " style="border-top-width: 1px" v-if="pagamentoBoleto">
              <span>
                <img :src="icons.boleto" alt="pix" style="width: 30px" />
              </span>
              <span class="container">Boleto</span>
              <span class="align-self-center h3 mt-2" style="color: var(--cor-principal)">&#10097;</span>
            </li>

            <!-- v-if="pagamentoComCartao" -->
            <li class="
              list-group-item
                px-4
                d-flex
                justify-content-between
                align-items-center" v-for="(cartao, index) in cartoes" :key="index" style="border-top-width: 1px">
              <button class="btn btn-link" style="margin-left:-63px" @click="excluirCartao(cartao)">
                <img style="width: 20px; filter: brightness(2) saturate(0)" src="@/assets/images/delete.png" />
              </button>

              <span class="container" @click="prosseguirConfirmacaoPagamento('CARTAO_CREDITO', cartao)">
                <span>
                  <img :src="icons.creditCard" alt="cartão de crédito" style="width: 30px" />
                </span>
                <span class="container">{{ cartao.bandeira }}
                  <span class="ml-2">
                    **** **** ****
                    {{
                      cartao.ultimosDigitos.replace("(não verificado)", "")
                    }}
                  </span>
                </span>
              </span>
              <span @click="prosseguirConfirmacaoPagamento('CARTAO_CREDITO', cartao)" class="align-self-center h3 mt-2"
                style="color: var(--cor-principal)">&#10097;</span>
            </li>
            <li @click="adicionarCartao" class="
                list-group-item
                px-4
                d-flex
                justify-content-between
                align-items-center
              " style="border-top-width: 1px"  v-if="pagamentoComCartao">
              <span>
                <img :src="icons.creditCard" alt="cartão de crédito" style="width: 30px" />
              </span>
              <span class="container">Cadastrar Cartão</span>
              <span class="align-self-center h3 mt-2" style="color: var(--cor-principal)">&#10097;</span>
            </li>
          </ul>
          <div class="
              mt-3
              mb-5
              px-3
              col-12
              d-flex
              flex-column flex-lg-row
              justify-content-between
            ">
            <button class="btn btn-secondary px-lg-5 mt-4 py-2" @click="goToStep('endereco')">
              VOLTAR
            </button>
            <button class="btn btn-outline-secondary py-2 px-lg-5 mt-4" @click="cancelPayment()">
              LIMPAR CARRINHO
            </button>
          </div>
        </div>
      </div>
    </article>
    <div class="endereco" v-if="cartaoForm">
      <div class="embed-responsive embed-responsive-1by1" style="height: 70%; min-height: 600px" v-if="urlFormCartao">
        <iframe :src="urlFormCartao" class="embed-responsive-item"></iframe>
      </div>
      <br />
      <div class="mx-4 mb-2">
        <button @click="toggleCartaoForm" class="col btn btn-style">
          Voltar
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import { APIService } from "../../APIService";
import icons from "@/shared/components/SvgIcon.js";

const apiService = new APIService();

export default {
  name: "StepPagamento",
  components: {},
  props: ["objPedido"],
  data() {
    return {
      URL_SLUG: window.URL_SLUG,
      codigoRede: window.APP_ORIGIN,
      pagamento: { valor: null },
      carteira: {},
      cartoes: [],
      carrinho: { id: null },
      btnLoading: false,
      urlFormCartao: "",
      cartaoForm: false,
      pagamentoComCartao: false,
      pagamentoPix: false,
      pagamentoBoleto: false,
      cobrancaPix: null,
      intervalFetchStatusCartao: null,
      icons,
    };
  },
  mounted() {
    this.carrinho.id = this.objPedido.id;
    this.pagamento.valor = this.objPedido.valorTotal;
    apiService.getCarteira().then((res) => {
      this.carteira = res;
    });
    apiService.getListaCartoes().then((res) => {
      this.cartoes = res;
    });
    apiService
      .getFuncionalidade(this.codigoRede)
      .then((res) => {
        this.pagamentoComCartao = res.some((e) => {
          return "PAGAMENTO_COMPRA_CARTAOCREDITO" == e.funcionalidade;
        });

        this.pagamentoPix = res.some((e) => {
          return "PAGAMENTO_PIX" == e.funcionalidade;
        });

        const funcBoleto = res.filter(o => o.funcionalidade === "PAGAMENTO_BOLETO")[0];
        if (funcBoleto) {
          this.pagamentoBoleto = funcBoleto.ativo === true;
        }
      })
      .catch((error) => {
        console.log(error)
        this.pagamentoComCartao = false;
        this.pagamentoPix = false;
      });
  },
  methods: {
    excluirCartao(cartao) {
      this.$swal({
        title: "Tem certeza de que quer excluir o cartão?",
        html: `<div class="pt-3">**** **** **** 5011</div><small>MASTERCARD</small>`,
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => {
          apiService.removerCartao(cartao.codigoCartao).then(() => {
            apiService.getListaCartoes().then((resCartao) => {
              this.cartoes = resCartao;
              this.$swal({
                title: "Cartão removido com sucesso",
                confirmButtonText: "Fechar",
              });
            });
          });
        },
      });
    },
    prosseguirConfirmacaoPagamento(metodo, cartao) {
      if (cartao == null) {
        cartao = {};
      }
      this.$emit("dadosPagamento", {
        valor: this.pagamento.valor,
        carrinhoId: this.carrinho.id,
        metodo: metodo,
        codigoCartao: cartao.codigoCartao,
        cartaoBandeira: cartao.bandeira,
        cartaoUltimosDigitos: cartao.ultimosDigitos,
        codigoLoja: this.objPedido.redeLoja?.codigoLoja,
        nomeLoja: this.objPedido.redeLoja?.nome,
      });
      this.goToStep("confirmacaoPagamento");
    },
    adicionarCartao() {
      apiService
        .dadosApp()
        .then(
          (response) => !response.pessoa.endereco && this.goToStep("endereco")
        );
      var cartaoToken = {
        cartaoOrigem: "MARKETPLACE",
        codigoReferencia: this.objPedido.codigoReferencia,
      };
      apiService.cadastrarCartao(cartaoToken).then((res) => {
        this.urlFormCartao = res.url;
        this.toggleCartaoForm();
        this.VerificarCartao(res.codigoCartao);
      });
    },
    adicionarCobrancaPix() {
      this.btnLoading = true;
      if (!this.cobrancaPix) {
        const pagamentoDTO = {
          codigoLoja: this.$store.state.pedido.itens[0].produto.redeLoja.codigoLoja,
          metodo: 'PIX',
          nomeLoja: this.$store.state.pedido.itens[0].produto.redeLoja.nome,
          valor: +this.objPedido.valorTotal,
          quantidadeParcelas: 1
        };

        apiService.criarCobrancaPixParaPedido(pagamentoDTO, this.objPedido.id).then((res) => {
          this.btnLoading = false;
          this.$router.push(`/pagamento-pix/${res.id}`);
          this.cobrancaPixCriada("Pix");
        }).catch((error) => {
          this.btnLoading = false;
          this.mensagemErro = error.response.data?.result
            ? error.response.data.result
            : "Ocorreu um problema ao processar o pagamento, tente novamente.";
        });
        // } else {
        // this.loading = false;
        // this.mensagemSucesso = "Pix criado com sucesso.";alert(this.mensagemSucesso)
        // this.$router.push(`/pagamento-pix/${res.id}`);
        // this.cobrancaPix = res;
      }
    },
    VerificarCartao(codigoCartao) {
      this.intervalFetchStatusCartao = setInterval(() => {
        apiService.cartaoConta(codigoCartao).then((res) => {
          if (res.ativo) {
            apiService.getListaCartoes().then((resCartao) => {
              this.cartoes = resCartao;
              this.toggleCartaoForm();
              clearInterval(this.intervalFetchStatusCartao);
            });
          }
        });
      }, 5000);
    },
    destroyed() {
      clearInterval(this.intervalFetchStatusCartao);
    },
    toggleCartaoForm() {
      if (this.cartaoForm) clearInterval(this.intervalFetchStatusCartao);
      this.cartaoForm = !this.cartaoForm;
    },
    cancelPayment() {
      this.$swal({
        title: "Tem certeza que deseja limpar o carrinho? Todos os produtos serão removidos!",
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        preConfirm: () => {
          this.loading = true;
          apiService.cancelPayment(this.objPedido.id).then(() => {
            localStorage.removeItem("codigoLoja");
            localStorage.removeItem("idCarrinho");
            this.$store.dispatch("limparPedido");
            this.$router.push(`/`);
          });
        },
      });
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    goToStep(step) {
      this.$emit("goToStep", step);
    },
    cobrancaCriada(nome) {
      this.$swal({
        text: nome + " criado com sucesso. Após o processamento do pagamento seu pedido será processado.",
        confirmButtonText: "ok",
      }).finally(() => (this.btnLoading = false));
    },
    adicionarBoleto() {
      this.btnLoading = true;
      // if (!this.cobrancaPix) {
      const pagamentoDTO = {
        codigoLoja: this.$store.state.pedido.itens[0].produto.redeLoja.codigoLoja,
        metodo: 'BOLETO',
        nomeLoja: this.$store.state.pedido.itens[0].produto.redeLoja.nome,
        valor: +this.objPedido.valorTotal,
        quantidadeParcelas: 1
      };

      apiService.criarBoletoParaPedido(pagamentoDTO, this.objPedido.id).then((res) => {
        this.btnLoading = false;

        this.$router.push(`/planos/checkout/boleto/${this.objPedido.id}/${res.id}/marketplace`);
        this.cobrancaCriada("Boleto");
      }).catch((error) => {
        this.btnLoading = false;
        this.mensagemErro = error.response.data?.result
          ? error.response.data.result
          : "Ocorreu um problema ao processar o pagamento, tente novamente.";
      });
    }
  }
}
</script>
<style scoped lang="scss">
.pagamentoCartao {
  position: relative;
  height: 600px;
}

.endereco {
  position: absolute;
  top: -46px;
  left: 0;
  background-color: #f2f2f2;
  width: 100%;
  height: 685px;
  overflow: auto;
  z-index: 2;
}
</style>
